import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-documents', storeModule.createStoreModule('sales-documents'))
